<template>
    <report-section
        :report-type="$options.ReportTypes.ShipmentTracking"
        :report-title="$t('general.menu.reports.shipmentTracking')"
    />
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { $t } from '@/translations';
import { ReportTypes } from '@/core/enums';
import ReportSection from '@/views/reports/ReportSection';

export default {
    name: 'ShipmentTracking',
    components: {
        ReportSection,
    },
    ReportTypes,
};
</script>
